import environment from 'platform/utilities/environment';

export const SUBMIT_URL = '/v0/education_benefits_claims/1995';

export const CLAIMANT_INFO_ENDPOINT = `${
  environment.API_URL
}/meb_api/v0/claimant_info`;

export const FETCH_CLAIMANT_INFO = 'FETCH_CLAIMANT_INFO';
export const FETCH_CLAIMANT_INFO_SUCCESS = 'FETCH_CLAIMANT_INFO_SUCCESS';
export const FETCH_CLAIMANT_INFO_FAILURE = 'FETCH_CLAIMANT_INFO_FAILURE';
